'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.faqs = void 0;
var adapter_1 = require("../adapter");
var FAQs = /** @class */ (function () {
    function FAQs() {
    }
    /**
     * Get FAQs for given language that have question and answer
     */
    FAQs.prototype.get = function (lang) {
        var params = { lang: lang };
        return adapter_1.adapter.faqs.get(params).then(function (values) {
            return values
                .filter(function (entry) {
                return entry.question && entry.answer;
            })
                .sort(function (a, b) { return (a.position < b.position ? -1 : 1); });
        });
    };
    /**
     * Get promotions by category id
     */
    FAQs.prototype.getByCatId = function (catId) {
        var params = { catId: catId };
        return adapter_1.adapter.faqs.getByCatId(params);
    };
    return FAQs;
}());
exports.faqs = new FAQs();
